// @flow
import * as React from 'react'
/*:: import type {ComponentType} from 'react' */
import styled from 'styled-components'
import {translate} from 'react-i18next'
import {
  Banner,
  Link,
  NarrowSection,
  Section,
  SectionContent,
  SectionImage,
  SplitSection,
  Traits,
  Trait,
  styles
} from 'tutellus-ui'

import {Page} from './Page'

const ImproveSection = styled(SplitSection)`
    @media ${styles.media.tablet} {
        & ${SectionImage} {
            max-width: 150%;
            margin-left: -11em;
        }
    }
`
ImproveSection.displayName = 'ImproveSection'

const StudentsSection = styled(SplitSection)`
    @media ${styles.media.tablet} {
        & > ${SectionContent} {
            & p {
                margin-bottom: 0;
            }
        }
    }
`
StudentsSection.displayName = 'StudentsSection'

export const Home = translate('home')(({t, className}) =>
  <Page classname={className}>
    <Banner big background_url={t('background_url')}
      title={t('title')}>
      { t('description') }
    </Banner>
    <Section title={t('whatis_title')}>
      <p>{ t('whatis_description') }</p>
      <Traits>{
        JSON.parse(t('whatis_traits')).map(name =>
          <Trait key={name}
            title={t(`${name}_title`)}
            icon={t(`${name}_icon`)}>
            { t(`${name}_description`) }
          </Trait>
        )
      }</Traits>
    </Section>
    <SplitSection light
      title={t('learn_title')}
      image={t('learn_image')}>
      <p>{ t('learn_description') }</p>
    </SplitSection>
    <ImproveSection dark
      reverse
      align='bottom'
      title={t('improve_title')}
      image={t('improve_image')}>
      <p>{ t('improve_description') }</p>
    </ImproveSection>
    <SplitSection light
      align='bottom'
      overflow='top'
      title={t('students_title')}
      image={t('students_image')}>
      <p>{ t('students_description') }</p>
    </SplitSection>
    <NarrowSection dark title={t('register_title')}>
      <Link button primary
        href={t('urls:register')}
      >
        { t('register_cta') }
      </Link>
    </NarrowSection>
  </Page>
)



// WEBPACK FOOTER //
// ./src/pages/Home.js